import styled from 'vue-styled-components';

export const Wrapper = styled.div`
  display: flex;
  color: inherit;
  justify-content: center;
  padding: 1rem;
  width: 100%;

`;
